function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8333 15.5V2.16667C13.8333 1.24619 13.0871 0.5 12.1667 0.5H3.83333C2.91286 0.5 2.16667 1.24619 2.16667 2.16667V15.5M13.8333 15.5L15.5 15.5M13.8333 15.5H9.66667M2.16667 15.5L0.5 15.5M2.16667 15.5H6.33333M5.5 3.83331H6.33333M5.5 7.16665H6.33333M9.66667 3.83331H10.5M9.66667 7.16665H10.5M6.33333 15.5V11.3333C6.33333 10.8731 6.70643 10.5 7.16667 10.5H8.83333C9.29357 10.5 9.66667 10.8731 9.66667 11.3333V15.5M6.33333 15.5H9.66667",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgOfficeBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBuilding);
export default __webpack_public_path__ + "static/media/office-building.5f16e7a3.svg";
export { ForwardRef as ReactComponent };